import React, { Component } from 'react';
import {
    Grid,
    Card,
    CardContent,
    Typography,
    Box,
    TextField,
    MenuItem,
    Button,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    TablePagination,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Drawer,
    Stack,
    Divider,
    Menu
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs'; // Certifique-se de ter o dayjs instalado
import CloseIcon from '@mui/icons-material/Close';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import {
    Search as SearchIcon,
    LocalMallOutlined,
    LocalShippingOutlined,
    CreditCardOutlined,
    TrendingUpOutlined,
    Add as AddIcon,
    FileDownloadOutlined,
    CalendarTodayOutlined,
    MoreHoriz as MoreHorizIcon
} from '@mui/icons-material';

import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const PERIODOS_MAP = {
    'Selecione': 'selecione',
    'Hoje': 'hoje',
    'Ontem': 'ontem',
    'Últimos 7 dias': 'ultimos_7',
    'Últimos 14 dias': 'ultimos_14',
    'Últimos 30 dias': 'ultimos_30',
    'Últimos 60 dias': 'ultimos_60',
    'Últimos 90 dias': 'ultimos_90',
    'Este mês': 'este_mes',
    'Mês anterior': 'mes_anterior',
    'Este ano': 'este_ano',
    'Todo o período': 'todo_periodo',
    'Personalizado': 'personalizado'
};

class Orders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: '',
            statusFilter: 'pago,approved,processed',
            paymentFilter: 'Todos',
            dateRange: 'Hoje',
            // Estados de Paginação
            page: 0,
            rowsPerPage: 10,
            // Dados vindos da API
            apiData: {
                faturamento: 0,
                receitaLiquida: 0,
                pedidos: 0,
                itensVendidos: 0,
                chartData: [],
                vendas: []
            },
            personalize: {


            },
            detailProduct: {},
            chartDays: [],
            anchorEl: null,
            selectedVenda: null,
        };
    }

    componentDidMount() {
        document.title = "Pedidos";
        this.fetchOrders();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.dateRange !== this.state.dateRange ||
            prevState.statusFilter !== this.state.statusFilter ||
            prevState.paymentFilter !== this.state.paymentFilter
        ) {
            // this.fetchOrders();
        }
    }

    fetchOrders = () => {
        const { dateRange } = this.state;
        const queryPeriodo = PERIODOS_MAP[dateRange] || 'ultimos_30';

        fetch(`${process.env.REACT_APP_API_URL}/store/orders?periodo=${queryPeriodo}&status=${this.state.statusFilter}&payment=${this.state.paymentFilter}`, {
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error('Erro na requisição');
            })
            .then((data) => {
                this.setState({
                    apiData: data,
                    chartDays: data.chartDays || [],
                    page: 0 // Reseta para a primeira página ao buscar novos dados
                });
            })
            .catch(err => console.error("Erro ao buscar vendas:", err));
    };

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value, page: 0 }); // Reseta página ao filtrar
    };

    // Handlers de Paginação
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };

    handleExport = () => {
        console.log('Exportando dados...');
    };

    handleNewOrder = () => {
        console.log('Abrindo modal de novo pedido...');
    };


    ChipStatus(status) {
        switch (status) {
            case 'pendente':
                return <Chip label="Pendente" color="warning" size="small" />;
            case 'pago':
                return <Chip label="Pago" color="success" size="small" />;
            case 'cancelado':
                return <Chip label="Cancelado" color="error" size="small" />;
            case 'em_andamento':
                return <Chip label="Em andamento" color="warning" size="small" />;
            default:
                return <Chip label="Desconhecido" color="default" size="small" />;
        }
    }


    renderChart() {
        const { chartDays, apiData } = this.state;

        const data = {
            labels: chartDays,
            datasets: [
                {
                    label: 'Faturamento (R$)',
                    data: apiData.chartData || [],
                    borderColor: '#059669',
                    backgroundColor: ' rgba(5, 150, 105, 0.1)',
                    tension: 0.2,
                    fill: true,
                    yAxisID: 'y',
                },
            ]
        };

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { display: false },
            },
            scales: {
                y: {
                    type: 'linear',
                    display: true,
                    position: 'left',
                    min: 0,
                    title: { display: true, text: 'Faturamento (R$)' }
                },
                x: { grid: { display: false } }
            }
        };

        return <Line data={data} options={options} height={200} />;
    }
    handleOpenMenu = (event, venda) => {
        this.setState({ anchorEl: event.currentTarget, selectedVenda: venda });
    };

    handleCloseMenu = () => {
        this.setState({ anchorEl: null, selectedVenda: null });
    };

    handleStatusChange = (novoStatus) => {
        const { selectedVenda } = this.state;
        console.log(`Alterando status da venda ${selectedVenda.venda_id} para: ${novoStatus}`);
        // Adicione aqui a sua chamada de API para atualizar o status no banco de dados

        fetch(`${process.env.REACT_APP_API_URL}/store/orders/${selectedVenda.venda_id}`, {
            credentials: "include",
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ status: novoStatus })
        }).then(() => {
            this.setState((prevState) => ({
                apiData: {
                    ...prevState.apiData,
                    vendas: prevState.apiData.vendas.map((venda) => {
                        if (venda.venda_id === selectedVenda.venda_id) {
                            return {
                                ...venda,
                                status: novoStatus,
                            };
                        }
                        return venda;
                    }),
                },
            }))
        })

    };
    render() {
        const { apiData, searchQuery, statusFilter, paymentFilter, dateRange, page, rowsPerPage } = this.state;


        // Filtragem dinâmica das vendas
        const filteredVendas = (apiData.vendas || [])

        // Paginação local: fatiar a lista filtrada com base na página atual
        const paginatedVendas = filteredVendas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

        return (
            <Box sx={{ p: 0, backgroundColor: '#f8f9fa', minHeight: '100vh' }}>

                {/* ================= TOP CARDS ================= */}
                <Grid container spacing={4} sx={{ mb: 4 }}>
                    {/* Pedidos no período */}
                    <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Card sx={{ borderRadius: 3, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                            <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', p: 2.5 }}>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="body2" color="textSecondary" gutterBottom>
                                        Pedidos no período
                                    </Typography>
                                    <Typography variant="h4" sx={{ fontWeight: 'bold', my: 0.5 }}>
                                        {apiData.pedidos}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">
                                        {apiData.pedidos} pagos
                                    </Typography>
                                </Box>
                                <Box sx={{ bgcolor: '#f3e5f5', p: 1, borderRadius: 2, display: 'flex' }}>
                                    <LocalMallOutlined sx={{ color: '#9c27b0' }} />
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Itens Vendidos */}
                    <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Card sx={{ borderRadius: 3, boxShadow: '0 2px 8px rgba(0,0,0,0.05)', borderTop: '4px solid #fef3c7', bgcolor: '#fffdf5' }}>
                            <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', p: 2.5 }}>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="body2" sx={{ color: '#b45309' }} gutterBottom>
                                        Itens Vendidos
                                    </Typography>
                                    <Typography variant="h4" sx={{ fontWeight: 'bold', my: 0.5, color: '#b45309' }}>
                                        {apiData.itensVendidos}
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: '#b45309' }}>
                                        Produtos despachados
                                    </Typography>
                                </Box>
                                <Box sx={{ bgcolor: '#fef3c7', p: 1, borderRadius: 2, display: 'flex' }}>
                                    <LocalShippingOutlined sx={{ color: '#d97706' }} />
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Lucro Líquido */}
                    <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Card sx={{ borderRadius: 3, boxShadow: '0 2px 8px rgba(0,0,0,0.05)', borderTop: '4px solid #dbeafe', bgcolor: '#f8fafc' }}>
                            <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', p: 2.5 }}>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="body2" sx={{ color: '#1d4ed8' }} gutterBottom>
                                        Receita Líquida
                                    </Typography>
                                    <Typography variant="h4" sx={{ fontWeight: 'bold', my: 0.5, color: '#1d4ed8' }}>
                                        {apiData.receitaLiquida?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: '#2563eb' }}>
                                        Lucro após custos
                                    </Typography>
                                </Box>
                                <Box sx={{ bgcolor: '#dbeafe', p: 1, borderRadius: 2, display: 'flex' }}>
                                    <CreditCardOutlined sx={{ color: '#2563eb' }} />
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Receita Bruta (Faturamento) */}
                    <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Card sx={{ borderRadius: 3, boxShadow: '0 2px 8px rgba(0,0,0,0.05)', borderTop: '4px solid #d1fae5', bgcolor: '#f0fdf4' }}>
                            <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', p: 2.5 }}>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography variant="body2" sx={{ color: '#065f46' }} gutterBottom>
                                        Faturamento total
                                    </Typography>
                                    <Typography variant="h4" sx={{ fontWeight: 'bold', my: 0.5, color: '#065f46' }}>
                                        {apiData.faturamento?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: '#065f46' }}>
                                        Pedidos concluídos
                                    </Typography>
                                </Box>
                                <Box sx={{ bgcolor: '#d1fae5', p: 1, borderRadius: 2, display: 'flex' }}>
                                    <TrendingUpOutlined sx={{ color: '#059669' }} />
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                {/* ================= PERFORMANCE GRAPH ================= */}
                <Card sx={{ borderRadius: 3, p: 3, mb: 3, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Box>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                                Performance de Vendas
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Faturamento diário mapeado no período selecionado
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: '#059669' }} />
                                <Typography variant="caption" color="textSecondary">Faturamento bruto</Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ height: 220 }}>
                        {this.renderChart()}
                    </Box>
                </Card>

                {/* ================= GERENCIAR PEDIDOS ================= */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                            Gerenciar Vendas
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {filteredVendas.length} vendas listadas
                        </Typography>
                    </Box>
                    <Box>
                        <Button variant="contained" color="success" startIcon={<FileDownloadIcon />}>
                            Exportar
                        </Button>
                    </Box>
                </Box>

                {/* FILTROS */}
                <Grid container spacing={2} sx={{ mb: 3, alignItems: 'center' }}>
                    <Grid item size={{ xs: 12, sm: 2 }}>
                        <TextField
                            fullWidth
                            size="small"
                            name="searchQuery"
                            value={searchQuery}
                            onChange={this.handleInputChange}
                            placeholder="Buscar por ID ou pagamento..."
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon size="small" color="disabled" />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fff' } }}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, sm: 2 }}>
                        <TextField
                            select
                            label="Forma de Pagamento"
                            fullWidth
                            size="small"
                            name="paymentFilter"
                            value={paymentFilter}
                            onChange={this.handleInputChange}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fff' } }}
                        >
                            <MenuItem value="Todos">Todos</MenuItem>
                            <MenuItem value="credit_card">Cartão de Crédito</MenuItem>
                            <MenuItem value="debit_card">Cartão de Débito</MenuItem>
                            <MenuItem value="qr">Pix</MenuItem>
                            <MenuItem value="money">Dinheiro</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item size={{ xs: 12, sm: 2 }}>
                        <TextField
                            select
                            fullWidth
                            label="Status"
                            size="small"
                            name="statusFilter"
                            value={statusFilter}
                            onChange={this.handleInputChange}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fff' } }}
                        >
                            <MenuItem value="Todos">Todos Status</MenuItem>
                            <MenuItem value="pago,approved,processed">Pago</MenuItem>
                            <MenuItem value="Pendente">Pendente</MenuItem>
                            <MenuItem value="cancel">Cancelado</MenuItem>
                            <MenuItem value="failed">Falhou</MenuItem>
                            <MenuItem value="expired">Expirado</MenuItem>
                        </TextField>
                    </Grid>



                    <Grid item size={{ xs: 12, sm: 2 }}>
                        <TextField
                            select
                            fullWidth
                            size="small"
                            name="dateRange"
                            value={dateRange}
                            onChange={(event) => {
                                const { name, value } = event.target;
                                console.log(value)
                                if (value == "Personalizado") {
                                    this.setState({
                                        personalize: {
                                            dataInicio: new Date(),
                                        }
                                    })
                                } else {
                                    this.setState({ [name]: value, page: 0 }); // Reseta página ao filtrar
                                }

                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <CalendarTodayOutlined fontSize="small" />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fff' } }}
                        >
                            <MenuItem value="slc" disabled>Selecione</MenuItem>
                            {Object.keys(PERIODOS_MAP).map((label) => (
                                <MenuItem key={label} value={label}>
                                    {label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item size={{ xs: 12, sm: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth

                            startIcon={<SearchIcon />}
                            onClick={() => {
                                this.fetchOrders();
                            }}

                        >
                            Filtrar
                        </Button>
                    </Grid>
                </Grid>
                <Menu
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.handleCloseMenu}
                    PaperProps={{
                        sx: {
                            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                            borderRadius: '12px',
                            minWidth: '180px',
                            padding: '4px 0'
                        }
                    }}
                >
                    <Typography sx={{ px: 2, py: 1, fontWeight: 'bold', color: '#1e293b', fontSize: '0.95rem' }}>
                        Alterar status
                    </Typography>

                    {/* Opção: Pendente */}
                    <MenuItem onClick={() => this.handleStatusChange('pendente')} sx={{ gap: 1.5, py: 1, color: '#1e293b', fontWeight: '500' }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#f59e0b' }} />
                        Pendente
                    </MenuItem>

                    {/* Opção: Pago */}
                    <MenuItem onClick={() => this.handleStatusChange('pago')} sx={{ gap: 1.5, py: 1, color: '#1e293b', fontWeight: '500' }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#10b981' }} />
                        Pago
                    </MenuItem>

                    {/* Opção: Em andamento */}
                    <MenuItem onClick={() => this.handleStatusChange('em_andamento')} sx={{ gap: 1.5, py: 1, color: '#1e293b', fontWeight: '500' }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#3b82f6' }} />
                        Em andamento
                    </MenuItem>

                    {/* Opção: Concluído */}
                    <MenuItem onClick={() => this.handleStatusChange('concluido')} sx={{ gap: 1.5, py: 1, color: '#1e293b', fontWeight: '500' }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#10b981' }} />
                        Concluído
                    </MenuItem>

                    {/* Opção: Cancelado */}
                    <MenuItem onClick={() => this.handleStatusChange('cancelado')} sx={{ gap: 1.5, py: 1, color: '#1e293b', fontWeight: '500' }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#ef4444' }} />
                        Cancelado
                    </MenuItem>

                    <Divider sx={{ my: 1, borderColor: '#f1f5f9' }} />

                    {/* Opção: WhatsApp */}


                    {/* Opção: Excluir */}
                    <MenuItem onClick={() => { /* sua lógica de deletar */ this.handleCloseMenu(); }} sx={{ gap: 1.5, py: 1, color: '#dc2626', fontWeight: '500' }}>
                        <DeleteOutlineIcon fontSize="small" sx={{ color: '#dc2626' }} />
                        Excluir
                    </MenuItem>
                </Menu>
                {/* ================= TABELA DE VENDAS ATUALIZADA ================= */}
                <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: '0 2px 8px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
                    <Table>
                        <TableHead sx={{ bgcolor: '#f8fafc' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: '600', color: '#64748b' }}>Data e hora</TableCell>
                                <TableCell sx={{ fontWeight: '600', color: '#64748b' }}>Cliente</TableCell>
                                <TableCell sx={{ fontWeight: '600', color: '#64748b' }}>Produtos</TableCell>
                                <TableCell sx={{ fontWeight: '600', color: '#64748b' }} align='center'>Status do Pedido</TableCell>
                                <TableCell sx={{ fontWeight: '600', color: '#64748b' }}>Pagamento</TableCell>
                                <TableCell sx={{ fontWeight: '600', color: '#64748b' }}>Valor total</TableCell>
                                <TableCell align="center" sx={{ fontWeight: '600', color: '#64748b', pr: 4 }}>Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedVendas.length > 0 ? (
                                paginatedVendas.map((venda) => {
                                    const totalItens = (venda.itens || []).reduce((acc, item) => acc + item.quantidade, 0);
                                    const primeiroItemNome = venda.itens && venda.itens.length > 0 ? venda.itens[0].nome : 'teste';
                                    const dataFormatada = new Date(venda.data_venda).toLocaleString('pt-BR', {
                                        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
                                    });



                                    return (
                                        <TableRow key={venda.venda_id} hover sx={{ '& td': { py: 2, borderBottom: '1px solid #f1f5f9' } }}>
                                            {/* Data e hora */}
                                            <TableCell>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                                    <Typography sx={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#1e293b' }}>
                                                        #{venda.venda_id}
                                                    </Typography>


                                                    {venda.origem == "garcom" && <>
                                                        <Chip
                                                            label={"Garçom"}
                                                            size="small"
                                                            sx={{ bgcolor: '#6366f1', color: '#fff', fontWeight: 'bold', fontSize: '0.75rem', height: 20 }}
                                                        />
                                                    </>}

                                                    {venda.origem == "caixa" && <>
                                                        <Chip
                                                            label={"Caixa"}
                                                            size="small"
                                                            sx={{ bgcolor: '#6366f1', color: '#fff', fontWeight: 'bold', fontSize: '0.75rem', height: 20 }}
                                                        />
                                                    </>}

                                                    {venda.origem == "delivery" && <>
                                                        <Chip
                                                            label={"Delivery"}
                                                            size="small"
                                                            sx={{ bgcolor: '#ff0000', color: '#fff', fontWeight: 'bold', fontSize: '0.75rem', height: 20 }}
                                                        />
                                                    </>}


                                                </Box>
                                                <Typography variant="caption" color="textSecondary">
                                                    {dataFormatada}
                                                </Typography>
                                            </TableCell>

                                            {/* Cliente */}
                                            <TableCell>
                                                <Typography sx={{ fontWeight: '500', color: '#1e293b', fontSize: '0.9rem' }}>
                                                    {venda.cliente_nome || '---'}
                                                </Typography>
                                                <Typography variant="caption" color="textSecondary">
                                                    {venda.cliente_telefone || '---'}
                                                </Typography>
                                            </TableCell>

                                            {/* Produtos */}
                                            <TableCell>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>

                                                    <Box>
                                                        <Typography sx={{ fontWeight: '500', fontSize: '0.9rem', color: '#1e293b' }}>
                                                            {totalItens} {totalItens > 1 ? 'itens' : 'item'}
                                                        </Typography>
                                                        <Typography variant="caption" color="textSecondary">
                                                            {primeiroItemNome}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </TableCell>

                                            {/* Status do Pedido */}
                                            <TableCell align='center'>
                                                <Box>
                                                    {venda.status}
                                                </Box>
                                            </TableCell>

                                            {/* Pagamento */}
                                            <TableCell>
                                                {venda.forma_pagamento ? (
                                                    <Box>
                                                        <Chip
                                                            label={venda.forma_pagamento}
                                                            size="small"
                                                            sx={{ bgcolor: '#f1f5f9', color: '#334155', fontWeight: '500', textTransform: 'capitalize' }}
                                                        />

                                                    </Box>
                                                ) : (
                                                    <Typography color="textSecondary">---</Typography>
                                                )}
                                            </TableCell>

                                            {/* Valor Total */}
                                            <TableCell sx={{ fontWeight: 'bold', color: '#1e293b', fontSize: '0.95rem' }}>
                                                {venda.total_venda?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                            </TableCell>

                                            {/* Ações */}
                                            <TableCell align="right" sx={{ pr: 4 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
                                                    <Button
                                                        variant="text"
                                                        size="small"
                                                        onClick={() => {
                                                            console.log(venda);
                                                            this.setState({ detailProduct: venda });
                                                        }}
                                                        sx={{ textTransform: 'none', color: '#334155', fontWeight: '500', '&:hover': { bgcolor: '#f1f5f9' } }}
                                                    >
                                                        Ver detalhes
                                                    </Button>

                                                    <IconButton
                                                        size="small"
                                                        onClick={(e) => this.handleOpenMenu(e, venda)}
                                                    >
                                                        <MoreHorizIcon fontSize="small" sx={{ color: '#64748b' }} />
                                                    </IconButton>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={7} align="center" sx={{ py: 6, color: 'text.secondary', fontStyle: 'italic' }}>
                                        Nenhuma venda encontrada para os filtros selecionados.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    {/* ================= PAGINAÇÃO DO MATERIAL UI ================= */}
                    <TablePagination
                        component="div"
                        count={filteredVendas.length}
                        page={page}
                        onPageChange={this.handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                        labelRowsPerPage="Linhas por página:"
                        labelDisplayedRows={({ from, to, count }) =>
                            `${from}-${to} de ${count}`
                        }
                    />
                </TableContainer>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Dialog
                        open={Object.keys(this.state.personalize).length > 0}
                        onClose={() => {
                            this.setState({
                                personalize: {},
                                dataInicio: null, // Limpa ao fechar (opcional)
                                dataFim: null
                            })
                        }}
                        maxWidth="xs"
                        PaperProps={{
                            sx: { borderRadius: '16px', padding: 2, maxWidth: '600px', width: '100%' }
                        }}
                    >
                        <DialogTitle sx={{ fontWeight: 'bold', pb: 1 }}>
                            Selecionar Período de Vendas
                        </DialogTitle>

                        <DialogContent>
                            {/* Box com display flex para colocar os campos lado a lado ou em coluna */}
                            <Box
                                display="flex"
                                flexDirection={{ xs: 'column', sm: 'row' }}
                                gap={2}
                                mt={1}
                            >
                                <DatePicker
                                    label="Data Início"
                                    format="DD/MM/YYYY"
                                    value={this.state.dataInicio}
                                    onChange={(newValue) => this.setState({ dataInicio: newValue })}
                                    slotProps={{ textField: { fullWidth: true } }}
                                />

                                <DatePicker
                                    label="Data Fim"
                                    format="DD/MM/YYYY"
                                    value={this.state.dataFim}
                                    onChange={(newValue) => this.setState({ dataFim: newValue })}
                                    slotProps={{ textField: { fullWidth: true } }}
                                    // Validação simples: não deixa escolher uma data fim menor que a de início
                                    minDate={this.state.dataInicio || undefined}
                                />
                            </Box>
                        </DialogContent>

                        <DialogActions sx={{ px: 3, pb: 1 }}>
                            <Button
                                onClick={() => this.setState({ personalize: {} })}
                                color="inherit"
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={() => {
                                    const { dataInicio, dataFim } = this.state;
                                    const a = dataInicio.format('YYYY-MM-DD');
                                    const b = dataFim.format('YYYY-MM-DD');
                                    fetch(`${process.env.REACT_APP_API_URL}/store/orders?periodo=personalizado&dataInicio=${a}&dataFim=${b}&status=${this.state.statusFilter}&payment=${this.state.paymentFilter}`, {

                                        credentials: "include",
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                    }).then((response) => {
                                        if (response.ok) {
                                            return response.json();
                                        }
                                        throw new Error('Erro na requisição');
                                    })
                                        .then((data) => {
                                            this.setState({
                                                apiData: data,
                                                chartDays: data.chartDays || [],
                                                dateRange: 'slc',
                                                page: 0, // Reseta para a primeira página ao buscar novos dados
                                                personalize: {},
                                            });
                                        })
                                        .catch(err => console.error("Erro ao buscar vendas:", err));

                                }}
                                variant="contained"
                                color="primary"
                                // Desabilita o botão se o usuário não escolheu as duas datas
                                disabled={!this.state.dataInicio || !this.state.dataFim}
                            >
                                Buscar Resultados
                            </Button>
                        </DialogActions>
                    </Dialog>
                </LocalizationProvider>

                <Drawer
                    anchor={"right"}
                    open={Object.keys(this.state.detailProduct).length > 0}
                    onClose={() => this.setState({ detailProduct: {} })}
                >
                    <Box sx={{ width: 400 }}>
                        {/* Botão de Fechar */}
                        <IconButton
                            aria-label="close"
                            sx={{ position: 'absolute', right: 12, top: 12, color: 'text.secondary' }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>

                        <CardContent>
                            {/* Cabeçalho do Pedido */}
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="h6" component="h2" sx={{ fontWeight: 700, color: '#1a1a2e' }}>
                                    Pedido #{this.state.detailProduct.venda_id}
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                                    {new Date(this.state.detailProduct.data_venda).toLocaleString({ day: '2-digit', month: '2-digit', year: 'numeric' })}

                                </Typography>
                            </Box>



                            {/* Itens do Pedido */}
                            <Box sx={{ border: '1px solid #f0f0f5', borderRadius: 3, p: 2, mb: 2 }}>
                                <Typography variant="caption" sx={{ fontWeight: 700, color: '#8c8ca1', textTransform: 'uppercase', display: 'block', mb: 1.5 }}>
                                    Itens do Pedido
                                </Typography>

                                {this.state.detailProduct.itens?.map((item, index, arr) => (
                                    <Box key={item.id || index}>
                                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
                                            <Stack direction="row" spacing={2} alignItems="center" sx={{ flexGrow: 1, minWidth: 0 }}>
                                                <Box
                                                    sx={{
                                                        width: 50,
                                                        height: 50,
                                                        borderRadius: 2,
                                                        border: '1px solid #e0e0e0',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: '#fcfcfc',
                                                        flexShrink: 0
                                                    }}
                                                >
                                                    <Typography variant="body2" sx={{ color: '#555', fontWeight: 500, textTransform: 'lowercase' }}>

                                                    </Typography>
                                                </Box>
                                                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                                                    <Typography variant="body1" sx={{ fontWeight: 600, noWrap: true, textOverflow: 'ellipsis', overflow: 'hidden' }}>
                                                        {item.produto_name}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                                        {item.quantidade}x · {item.valor_venda?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                    </Typography>
                                                </Box>
                                            </Stack>
                                            <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a2e', ml: 1, flexShrink: 0 }}>
                                                {(item.quantidade * item.valor_venda)?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                            </Typography>
                                        </Stack>

                                        {index < arr.length - 1 && <Divider sx={{ my: 1.5, borderColor: '#f9f9fb' }} />}
                                    </Box>
                                ))}
                            </Box>

                            {/* Total */}
                            <Box sx={{ backgroundColor: '#f5f5fa', borderRadius: 3, p: 2, mb: 2 }}>
                                <Stack direction="row" justifyContent="between" alignItems="center">
                                    <Box sx={{ flexGrow: 1 }}>
                                        <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '1.1rem' }}>Total</Typography>
                                        <Typography variant="body2" sx={{ color: '#6d6d80' }}>Pagamento: {this.state.detailProduct.forma_pagamento}</Typography>
                                    </Box>
                                    <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a1a2e' }}>
                                        {this.state.detailProduct.total_venda?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                    </Typography>
                                </Stack>
                            </Box>



                            {/* Botões de Ação Inferiores */}
                            <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                                <Button
                                    variant="outlined"
                                    fullWidth
                                    startIcon={<PrintIcon />}

                                    onClick={() => {
                                        const venda = this.state.detailProduct;
                                        if (!venda || !venda.itens) return;

                                        // Cria a janela oculta para envio à impressora
                                        const janelaImpressao = window.open('', '_blank', 'width=320,height=600');

                                        // Mapeia os itens formatando para cupom
                                        const itensFormatados = venda.itens.map(item => `
            <div class="item-row">
                <div class="item-desc">${item.quantidade}x ${item.produto_name}</div>
                <div class="item-val">${item.valor_total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
            </div>
        `).join('');

                                        janelaImpressao.document.write(`
            <html>
            <head>
                <title>Cupom Pedido #${venda.venda_id}</title>
                <style>
                    /* Configurações de página para bobina de 80mm */
                    @page {
                        size: 80mm auto; /* Força o tamanho da largura em 80mm e altura dinâmica */
                        margin: 0;       /* Remove margens do navegador (tira a URL e a Data do topo) */
                    }
                    
                    body {
                        font-family: 'Courier New', Courier, monospace;
                        font-size: 11px;
                        line-height: 1.2;
                        width: 74mm;    /* Área útil real de impressão em uma bobina de 80mm */
                        margin: 0 auto;
                        padding: 10px 2px;
                        color: #000;
                        background-color: #fff;
                    }

                    .text-center { text-align: center; }
                    .bold { font-weight: bold; }
                    
                    /* Tarjeta de Reimpressão */
                    .reimpressao-tag {
                        font-size: 13px;
                        font-weight: bold;
                        border: 2px dashed #000;
                        padding: 5px;
                        margin-bottom: 12px;
                        text-align: center;
                    }

                    .divider { 
                        border-top: 1px dashed #000; 
                        margin: 8px 0; 
                    }

                    /* Estrutura de Linhas (Flexbox de alta compatibilidade) */
                    .item-row { 
                        display: flex; 
                        justify-content: space-between; 
                        margin-bottom: 5px; 
                        align-items: flex-start;
                    }
                    .item-desc { 
                        max-width: 70%; 
                        word-wrap: break-word; 
                        text-transform: uppercase;
                    }
                    .item-val { 
                        white-space: nowrap; 
                    }

                    .total-section {
                        font-size: 13px;
                        font-weight: bold;
                        margin-top: 5px;
                    }
                </style>
            </head>
            <body>

                <div class="reimpressao-tag">
                    *** REIMPRESSÃO ***
                </div>

                <div class="text-center">
                    <span class="bold" style="font-size: 13px;">PEDIDO #${venda.venda_id}</span><br/>
                    <span>LOJA: ${venda.loja}</span><br/>
                    <span>DATA: ${new Date(venda.data_venda).toLocaleString('pt-BR')}</span>
                </div>

                <div class="divider"></div>
                
                <div class="bold" style="margin-bottom: 6px;">ITENS DO PEDIDO</div>
                ${itensFormatados}
                
                <div class="divider"></div>

                <div class="item-row total-section">
                    <span>TOTAL:</span>
                    <span>${venda.total_venda.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                </div>
                
                <div class="item-row" style="margin-top: 5px;">
                    <span>PAGAMENTO:</span>
                    <span class="bold">${(venda.forma_pagamento || 'NÃO INFORMADO').toUpperCase()}</span>
                </div>
                
                <div class="item-row">
                    <span>STATUS:</span>
                    <span class="bold">${(venda.status || '').toUpperCase()}</span>
                </div>

                <div class="divider"></div>
                
                <div class="text-center" style="margin-top: 10px; font-size: 9px; letter-spacing: 1px;">
                 
                </div>

                <div style="height: 35px;"></div>

                <script>
                    window.onload = function() {
                        window.print();
                        setTimeout(function() { window.close(); }, 300);
                    };
                </script>
            </body>
            </html>
        `);

                                        janelaImpressao.document.close();
                                    }}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: 3,
                                        color: 'text.primary',
                                        borderColor: '#e0e0e0',
                                        py: 1,
                                        fontWeight: 500
                                    }}
                                >
                                    Imprimir
                                </Button>
                                <Button
                                    variant="outlined"
                                    fullWidth
                                    startIcon={<ShareIcon />}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: 3,
                                        color: 'text.primary',
                                        borderColor: '#e0e0e0',
                                        py: 1,
                                        fontWeight: 500
                                    }}
                                >
                                    Compartilhar
                                </Button>
                            </Stack>




                        </CardContent>
                    </Box>

                </Drawer>


            </Box>
        );
    }
}

export default Orders;